const HERO_IMG = "https://static.lumi.new/6a/6a4cb1bbb612422ca564dbfdac88aecd.webp"

export default function HeroSection() {
  return (
    <section
      className="relative min-h-[92vh] flex items-center overflow-hidden"
      style={{ backgroundColor: "#0E8EA0" }}
    >
      {/* Decorative blobs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full opacity-20"
          style={{ backgroundColor: "#6CC4C4" }}
        />
        <div
          className="absolute bottom-0 -left-32 w-[400px] h-[400px] rounded-full opacity-15"
          style={{ backgroundColor: "#B038B2" }}
        />
        <div
          className="absolute top-1/2 right-1/3 w-64 h-64 rounded-full opacity-10"
          style={{ backgroundColor: "#F5C542" }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 w-full">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          {/* Left content */}
          <div className="pt-20 lg:pt-0">
            <div className="inline-block px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm mb-6 opacity-0 animate-fade-in">
              <span className="text-white/90 text-sm font-medium">
                Educação digital em inglês
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6 opacity-0 animate-fade-in-up animation-delay-100">
              Inglês <span style={{ color: "#F5C542" }}>prático e real</span>
              <br />
              para sua vida profissional
              <br />
              e pessoal.
            </h1>

            <p className="text-lg md:text-xl text-white/80 max-w-lg leading-relaxed mb-10 opacity-0 animate-fade-in-up animation-delay-300">
              Com método comprovado e certificado ao final.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 opacity-0 animate-fade-in-up animation-delay-500">
              <a
                href="#ecossistema"
                className="px-8 py-4 font-bold rounded-full text-base transition-all duration-300 hover:scale-105 hover:shadow-xl text-center"
                style={{ backgroundColor: "#F5C542", color: "#000" }}
              >
                Conheça o EW Pass
              </a>
              <a
                href="#quem-somos"
                className="px-8 py-4 border-2 border-white/40 text-white font-bold rounded-full text-base transition-all duration-300 hover:bg-white/10 text-center"
              >
                Saiba mais
              </a>
            </div>
          </div>

          {/* Right image */}
          <div className="hidden lg:flex justify-center opacity-0 animate-slide-right animation-delay-400">
            <img
              src={HERO_IMG}
              alt="Educação digital"
              className="w-full max-w-lg rounded-3xl shadow-2xl"
            />
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 60L60 55C120 50 240 40 360 35C480 30 600 30 720 38C840 46 960 62 1080 65C1200 68 1320 58 1380 53L1440 48V100H1380C1320 100 1200 100 1080 100C960 100 840 100 720 100C600 100 480 100 360 100C240 100 120 100 60 100H0V60Z" fill="white"/>
        </svg>
      </div>
    </section>
  )
}
